module.exports = {
  apiAuthenticateUrl: process.env.REACT_APP_API_AUTHENTICATE_URL,
  apiGeneralUrl: process.env.REACT_APP_API_GENERAL_URL,
  domain: process.env.REACT_APP_DOMAIN
}
